var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _vm.isVisible
      ? _c("div", { staticClass: "dialog-overlay" }, [
          _c("div", { staticClass: "dialog-content" }, [
            _c("div", { staticClass: "dialog-body" }, [
              _c("div", { staticClass: "dialog-title" }, [
                _vm._v(_vm._s(_vm.title))
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "dialog-message" }, [
                _vm._v(_vm._s(_vm.message))
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "dialog-buttons" }, [
                _c(
                  "div",
                  { staticClass: "cancel-btn btn", on: { click: _vm.cancel } },
                  [_vm._v(_vm._s(_vm.cancelText))]
                ),
                _vm._v(" "),
                _c(
                  "div",
                  {
                    staticClass: "confirm-btn btn",
                    on: { click: _vm.confirm }
                  },
                  [_vm._v(_vm._s(_vm.confirmText))]
                )
              ])
            ])
          ])
        ])
      : _vm._e()
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-878f35a2", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-878f35a2","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/notice_dialog.vue
// module id = null
// module chunks = 